import React from 'react';
import { IReviewsStats } from 'src/interfaces/reviews';

import { Space } from '@sravni/react-design-system';
import { StarFilled } from '@sravni/react-icons';

import { Block } from './components';
import { TotalReviews } from './icons/TotalReviews';
import styles from './rating-blocks.module.scss';

interface IRatingBlocksProps {
  reviewsStats: IReviewsStats;
}

export const RatingBlocks: React.FC<IRatingBlocksProps> = ({ reviewsStats }) => (
  <Space size={8} className={styles.wrapper}>
    <Block isReviewsCount reviewsStats={reviewsStats} description="отзывов" icon={<TotalReviews />} />
    <Block
      isReviewsCount={false}
      reviewsStats={reviewsStats}
      description="рекомендуют"
      icon={<StarFilled color="#B4B9C9" />}
    />
  </Space>
);
